import _defineProperty from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import React from 'react';
import classNames from 'classnames';
import s from './input.module.css';
var Content = function Content(_ref) {
  var children = _ref.children,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'end' : _ref$placement,
    onClick = _ref.onClick,
    _ref$pointer = _ref.pointer,
    pointer = _ref$pointer === void 0 ? false : _ref$pointer,
    dataTest = _ref.dataTest;
  return React.createElement("span", Object.assign({}, _defineProperty({}, "data-addon-".concat(placement), ''), {
    onClick: onClick,
    className: classNames(s.content, s[placement], pointer && s.pointer),
    "data-test": dataTest
  }), children);
};
export default Content;